// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"finish-schulte_wrapper__3ruxv","text":"finish-schulte_text__2XbOr","bold":"finish-schulte_bold__3xTJ7","panel":"finish-schulte_panel__3UsFF"};